import React, { useState, useEffect } from 'react';
import ToggleSwitch from './ToggleSwitch'; // Importar o novo componente

const AccessibilityMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    
    const [fontSize, setFontSize] = useState(() => parseFloat(localStorage.getItem('accessibility_font_size')) || 16);
    const [highContrast, setHighContrast] = useState(() => localStorage.getItem('accessibility_high_contrast') === 'true');
    const [underlineLinks, setUnderlineLinks] = useState(() => localStorage.getItem('accessibility_underline_links') === 'true');

    useEffect(() => {
        const root = document.documentElement;
        
        root.style.fontSize = `${fontSize}px`;
        localStorage.setItem('accessibility_font_size', fontSize);

        if (highContrast) {
            document.body.classList.add('high-contrast');
            localStorage.setItem('accessibility_high_contrast', 'true');
        } else {
            document.body.classList.remove('high-contrast');
            localStorage.setItem('accessibility_high_contrast', 'false');
        }

        if (underlineLinks) {
            document.body.classList.add('underline-links');
             localStorage.setItem('accessibility_underline_links', 'true');
        } else {
            document.body.classList.remove('underline-links');
            localStorage.setItem('accessibility_underline_links', 'false');
        }

    }, [fontSize, highContrast, underlineLinks]);

    const resetStyles = () => {
        setFontSize(16);
        setHighContrast(false);
        setUnderlineLinks(false);
    };

    return (
        <div className="fixed bottom-4 left-4 z-50">
            {isOpen && (
                <div className="bg-white p-4 rounded-lg shadow-2xl border w-64 mb-2">
                    <h3 className="font-bold text-lg mb-3 text-gray-800">Acessibilidade</h3>
                    <div className="space-y-4">
                        {/* Font Size */}
                        <div>
                            <p className="text-sm font-medium text-gray-600">Tamanho do Texto</p>
                            <div className="flex items-center space-x-2 mt-1">
                                <button onClick={() => setFontSize(s => Math.max(12, s - 1))} className="font-bold text-xl bg-gray-200 rounded-md h-8 w-8">-</button>
                                <span className="text-center w-8">{Math.round((fontSize/16)*100)}%</span>
                                <button onClick={() => setFontSize(s => Math.min(24, s + 1))} className="font-bold text-xl bg-gray-200 rounded-md h-8 w-8">+</button>
                            </div>
                        </div>

                        {/* High Contrast - AGORA USA O NOVO COMPONENTE */}
                        <div className="flex justify-between items-center">
                             <label htmlFor="highContrastToggle" className="text-sm font-medium text-gray-600">Alto Contraste</label>
                             <ToggleSwitch 
                                id="highContrastToggle"
                                isChecked={highContrast}
                                onChange={() => setHighContrast(!highContrast)}
                             />
                        </div>
                        
                        {/* Underline Links - AGORA USA O NOVO COMPONENTE */}
                         <div className="flex justify-between items-center">
                             <label htmlFor="underlineLinksToggle" className="text-sm font-medium text-gray-600">Sublinhar Links</label>
                             <ToggleSwitch
                                id="underlineLinksToggle"
                                isChecked={underlineLinks}
                                onChange={() => setUnderlineLinks(!underlineLinks)}
                             />
                        </div>

                    </div>
                     <button onClick={resetStyles} className="w-full mt-4 text-sm text-blue-600 hover:underline">Repor</button>
                </div>
            )}
            <button 
                onClick={() => setIsOpen(!isOpen)} 
                title="Opções de Acessibilidade"
                className="bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg h-14 w-14 flex items-center justify-center"
            >
                <i className="fas fa-universal-access fa-2x"></i>
            </button>
        </div>
    );
};

export default AccessibilityMenu;